// extracted by mini-css-extract-plugin
module.exports = {"root":"_2dQJwo9RAU8a"};